import { H5 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled, { css } from 'styled-components';

const largeTitleStyle = css<{ large?: boolean }>`
  ${QUERIES.largeTabletAndUp} {
    font-size: ${themeStyle.fontSize26};
    font-weight: ${themeStyle.fontBold};
    margin-bottom: 24px;
    margin-top: 48px;
    text-align: center;
  }
`;

export const Title = styled(H5)<{ large?: boolean }>`
  font-size: ${themeStyle.fontSize12};
  line-height: 1rem;
  margin-bottom: 12px;
  margin-top: 12px;

  ${({ large }) => large && largeTitleStyle}
`;
